import React from 'react';
import SaasReadinessBaseline from './SaasReadinessBaseline';
import {
  diagnosticCardStyle,
  emptyNoticeStyle,
  panelSubStyle,
  panelTitleStyle,
  rowMetaStyle,
  rowTitleStyle,
} from './dashboardStyles';

function severityLabel(severity) {
  if (severity === 'danger') return '바로 확인';
  if (severity === 'warning') return '주의';
  return '참고';
}

export default function PermissionDiagnostics({ overview }) {
  const diagnostics = overview?.diagnostics || [];

  if (!overview) return <div style={emptyNoticeStyle}>현황을 불러오는 중입니다.</div>;
  if (diagnostics.length === 0) {
    return (
      <>
        <div style={diagnosticCardStyle('info')}>
          <h3 style={panelTitleStyle}>권한 자가진단 정상</h3>
          <div style={panelSubStyle}>업무/기능 배정과 실제 권한이 일치합니다.</div>
        </div>
        <SaasReadinessBaseline baseline={overview?.saasBaseline} />
      </>
    );
  }

  return (
    <div>
      {diagnostics.map((issue) => (
        <section key={issue.type} style={diagnosticCardStyle(issue.severity)}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center' }}>
            <div>
              <h3 style={panelTitleStyle}>{issue.title}</h3>
              <div style={panelSubStyle}>{issue.message}</div>
            </div>
            <div style={{ ...rowTitleStyle, whiteSpace: 'nowrap' }}>
              {severityLabel(issue.severity)} {issue.count}
            </div>
          </div>
          <div style={{ marginTop: 10, display: 'grid', gap: 6 }}>
            {(issue.sample || []).map((item, idx) => (
              <div key={`${issue.type}-${idx}`} style={{ borderTop: '1px solid var(--border)', paddingTop: 6 }}>
                <div style={rowTitleStyle}>{item.employee || '-'} <span style={rowMetaStyle}>({item.loginId || '-'})</span></div>
                <div style={rowMetaStyle}>{item.item || '-'} · {item.code || '-'}</div>
              </div>
            ))}
            {issue.count > (issue.sample || []).length && (
              <div style={rowMetaStyle}>외 {issue.count - issue.sample.length}건이 더 있습니다.</div>
            )}
          </div>
        </section>
      ))}
      <SaasReadinessBaseline baseline={overview?.saasBaseline} />
    </div>
  );
}
